import { useRef, useState } from 'react';
import { Alert, Button, Card, InputNumber, Space, Statistic, List, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { requestEDocPackage } from '../../services/billingService';
import { useGlobalToast } from '../../context/ToastProvider';

export default function ManualBillingCard({ fleetId, billing, access, onRefresh }) {
  const { t } = useTranslation();
  const toast = useGlobalToast();
  const [quantity, setQuantity] = useState(240);
  const [busy, setBusy] = useState(false);
  const request = useRef(null);
  if (!billing?.enabled) return null;
  const submit = async () => {
    if (busy) return;
    setBusy(true);
    request.current ||= { requestId: crypto.randomUUID(), quantity };
    try {
      await requestEDocPackage(fleetId, request.current);
      request.current = null;
      toast({ title: t('manualBilling.requested'), status: 'success' });
      await onRefresh();
    } catch (error) { toast({ error, title: t('manualBilling.requestError'), status: 'error' }); }
    finally { setBusy(false); }
  };
  return <Card title={t('manualBilling.title')} style={{ marginBottom: 16 }}>
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Typography.Text>{t('manualBilling.explanation')}</Typography.Text>
      <Space wrap size="large">
        <Statistic title={t('manualBilling.purchased')} value={billing.purchased} />
        <Statistic title={t('manualBilling.issued')} value={billing.issued} />
        <Statistic title={t('manualBilling.balance')} value={billing.balance} valueStyle={{ color: billing.balance < 0 ? '#d46b08' : undefined }} />
      </Space>
      <Typography.Text>{t('manualBilling.paidThrough')}: {billing.paidThrough ? new Date(billing.paidThrough).toLocaleDateString() : '—'} · {t('manualBilling.graceDays', { count: billing.graceDays })}</Typography.Text>
      {access?.grace && <Alert type="warning" showIcon message={t('manualBilling.graceReminder', { date: new Date(access.expiresAt).toLocaleDateString() })} />}
      {billing.balance < 0 && <Alert type="warning" message={t('manualBilling.negative')} />}
      <Space wrap>
        <InputNumber aria-label={t('manualBilling.quantity')} min={1} max={1000000} precision={0} value={quantity} disabled={busy} onChange={value => { setQuantity(value); request.current = null; }} />
        <Button type="primary" loading={busy} disabled={!Number.isInteger(quantity) || quantity < 1} onClick={submit}>{t('manualBilling.request')}</Button>
      </Space>
      <List dataSource={billing.requests} locale={{ emptyText: t('manualBilling.noRequests') }} renderItem={item => <List.Item>
        {new Date(item.createdAt).toLocaleDateString()} · {item.quantity} eDocs · {t(`manualBilling.${item.status}`)}{item.reference ? ` · ${item.reference}` : ''}
      </List.Item>} />
    </Space>
  </Card>;
}
